import { isObject, type SimpleLoad, useApiLogisticsV1LoadsList } from 'api';
import { useState } from 'react';

import { AutocompleteField } from '../AutocompleteField/AutocompleteField';

type Props = {
  label: string;
  name: string;
  required?: boolean;
  size?: 'small' | 'medium';
  onSelectOption?: (value: SimpleLoad) => void;
  assignableToShipment?: string;
  hasShipment?: boolean;
  salesOrderSlug?: string;
};
export const LoadAutoComplete = ({
  label,
  name,
  required = false,
  assignableToShipment,
  hasShipment,
  salesOrderSlug,
  ...rest
}: Props) => {
  const [query, setQuery] = useState('');

  const { data, isLoading } = useApiLogisticsV1LoadsList({
    assignable_to_shipment: assignableToShipment,
    has_shipment: hasShipment,
    page_size: 50,
    sales_order_slug: salesOrderSlug,
    search: query,
  });
  return (
    <AutocompleteField<SimpleLoad>
      options={data?.results || []}
      loading={isLoading}
      {...rest}
      label={label}
      name={name}
      required={required}
      getOptionLabel={(option) => {
        if (isObject(option) && option?.label) {
          return option.label;
        }
        return '';
      }}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
    />
  );
};
